'use strict';

import SlickInit from '../components/SlickInit';

new SlickInit();
